import React from "react";

import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

const steps = ["File Upload", "Episode Details", "Summary"];

interface StepperPorps {
  activeStep: number;
  isUploadComplete?: boolean;
}

export default function StepperView({
  activeStep,
  isUploadComplete = false,
}: StepperPorps) {
  const modernGreen = "#10b981";
  const modernGreenLight = "#34d399";
  const activeColor = isUploadComplete ? modernGreen : "#1976d2";

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{
          "& .MuiStepLabel-root": {
            "& .MuiStepLabel-label": {
              fontSize: 16,
              fontWeight: 600,
              color: "#23272E",
              "&.Mui-active": {
                color: activeColor,
                fontWeight: 700,
              },
              "&.Mui-completed": {
                color: modernGreen,
                fontWeight: 600,
              },
            },
            "& .MuiStepLabel-iconContainer": {
              "& .MuiStepIcon-root": {
                fontSize: 28,
                "&.Mui-active": {
                  color: activeColor,
                },
                "&.Mui-completed": {
                  color: modernGreen,
                },
              },
            },
          },
          "& .MuiStepConnector-root": {
            "& .MuiStepConnector-line": {
              borderColor: "#e0e0e0",
              borderTopWidth: 3,
            },
            "&.Mui-active .MuiStepConnector-line": {
              borderColor: activeColor,
            },
            "&.Mui-completed .MuiStepConnector-line": {
              borderColor: modernGreenLight,
            },
          },
        }}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
